import React, { Component } from "react";
import PropTypes from "prop-types";

import i18n from "i18n-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactToPrint from "react-to-print";

import { APIHandler, PrintComponent } from "C4";
import { name } from "settings";

export default class Diploma extends Component {
  constructor(props) {
    super(props);

    this.state = {
      diplomaLoaded: false,
    };
  }

  setComponentRef = (ref) => {
    this.componentRef = ref;
  };

  reactToPrintContent = () => this.componentRef;

  toggle(diplomaLoaded) {
    this.setState({ diplomaLoaded });
  }

  render() {
    const { appId, firstName, lastName } = this.props;

    const image = `https://cms.travpromobile.com/api/app/diploma?first_name=${firstName}&last_name=${lastName}&app_id=${appId}`;
    const subject = encodeURIComponent(`${name} diploma`);
    const body = encodeURIComponent(image);

    return (
      <div style={{ display: "none" }} id="diploma" className="fancybox-share diploma">
        <PrintComponent
          appId={appId}
          firstName={firstName}
          lastName={lastName}
          ref={this.setComponentRef}
        />
        <div className="buttons__diploma">
          <ReactToPrint
            content={this.reactToPrintContent}
            trigger={() => (
              <div disabled={!this.state.diplomaLoaded} className="fancybox-share__button fancybox-share__button--fb">
                <FontAwesomeIcon icon={["fas", "print"]} />
                <span> {i18n.translate("reportCard.print")}</span>
              </div>
            )}
          />
          <a
            href={`mailto:?subject=${subject}&body=${body}`}
            className="fancybox-share__button fancybox-share__button--pt"
          >
            <FontAwesomeIcon icon={["fas", "at"]} />
            <span>{i18n.translate("reportCard.email")}</span>
          </a>
          <a
            href={APIHandler.getDownloadURL(
              image,
              `${name} Diploma ${firstName} ${lastName}`.replaceAll("&", "and"),
            )}
            className="fancybox-download__button fancybox-download__button--pt"
          >
            <FontAwesomeIcon icon={["fas", "download"]} />
            <span>{i18n.translate("reportCard.download")}</span>
          </a>
          <a
            href="https://stack.travpromobile.com/download.php?url=https://front.travpromobile.com/618/PolarPRO_Logo.zip"
            download="PolarPRO_Logo.zip"
            className="fancybox-polar__button fancybox-polar__button--pt"
          >
            <FontAwesomeIcon icon={["fas", "download"]} />
            <span>Download Certified PolarPro Logo</span>
          </a>
        </div>
      </div>
    );
  }
}

Diploma.propTypes = {
  appId: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
};

Diploma.defaultProps = {
  appId: -1,
  firstName: "",
  lastName: "",
};
